import {
    NavLink
  } from "react-router-dom";

import {ReactComponent as Logo } from '../img/logo.svg';

// si hay error de autentificación
import { ResetPass } from "../components/ResetPass";

import Navigation from '../components/Navigation';

// export async function loader() {
//   const pacientes = await API.getAllPacientes();
//   return { pacientes };
// }

export function ResetPassPage() {
  const isAuthenticated = !!sessionStorage.getItem("token");
  return (
    <>
      
      <div id="sidebar">
      {/* <ResetPass /> */}
        <div className="logo"><Logo /></div>
        
        {/* other code */}


        {/* other code */}
      </div>
      { isAuthenticated ? (
      <main id="main">
        <Navigation />
        <div id="detail">
          <ResetPass />
        </div>
      </main>
      ) : (
      <main id="main">
        <div id="detail">
          <ResetPass />
        </div>
      </main>
      ) }
    </>
  );
}